export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_23.34f197bd.jpg";